import { render, staticRenderFns } from "./InformationButton.vue?vue&type=template&id=06cfce24&scoped=true&"
import script from "./InformationButton.vue?vue&type=script&lang=ts&"
export * from "./InformationButton.vue?vue&type=script&lang=ts&"
import style0 from "./InformationButton.vue?vue&type=style&index=0&id=06cfce24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cfce24",
  null
  
)

export default component.exports